import styled from 'styled-components'
import Flex from 'Components/Flex'
import { FormElemGroup } from 'Components/Form'
import AddRecipientMulti from 'Layout/Modals/components/AddRecipientMulti'
import SwitchButton from 'Components/Form/SwitchButton'
import { BREAK_POINT_MD, BREAK_POINT_SM } from '@CSSVars/variables'
import { SAVED_ALERT_CAPTION_BG, PRIMARY_SECONDARY_COLOR,
  LINK_COLOR, SELECTED_ITEM_BG_COLOR } from '@CSSVars/colors'

export const _ListingAlertCard = styled(Flex)`
  background: white;
  padding: 30px 32px;
  margin-bottom: 24px;
  position: relative;
  max-width: 888px;
  border-radius: 10px;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column-reverse;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    padding: 20px;
  }

`

export const _DeletingIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #d3d3d345;
  z-index: 1;
`

export const _CTA = styled.div`
  width: 100%;
  background: ${SAVED_ALERT_CAPTION_BG};
  height: 47px;
  color: ${PRIMARY_SECONDARY_COLOR};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  margin-top: -2px;
`

export const _PreviewImgBlock = styled(Flex)`
  width: 50%;
  max-width: 400px;
  margin-right: 40px;
  min-width: 165px;
  position: relative;
  overflow: hidden;
  border: 1px solid transparent;
  border-radius: 5px;
  height: auto;

  button {
    position: absolute;
    bottom: 1vw;
/*    min-width: 128px;*/
    width: auto;
  }
  @media (hover:hover){
    &:hover{
      border: 1px solid ${LINK_COLOR};
      border-radius: 5px;
      ${_CTA} {
        color: ${LINK_COLOR};
      }
      img {
        transition: 1s ease;
        transform: scale(1.1);
      }
    }
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 50%;
    margin-right: 0;
    button {
      bottom: 18px;
    }
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    width: 100%;
  }
  &:active{
    border: 1px solid ${SELECTED_ITEM_BG_COLOR};
    border-radius: 5px;
    ${_CTA} {
      color: ${SELECTED_ITEM_BG_COLOR};
    }
  }

`

export const _FrequencyContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const _Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  margin-bottom: 15px;


`

export const _FrequencyGroup = styled(FormElemGroup)`
  max-width: 344px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap:12px;
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    max-width: initial;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    max-width: initial;
  }
`

export const _FrequencySelect = styled.div`
  width: 272px;
  .frequencySelect {
    height: 44px;
  }
  .dropdown {
    width: 272px;
    max-width: 100%;
    right: 0;
    left: unset;
    div:last-child {
      border-radius: 10px;
    }
   top: 44px !important;
  }
`

export const _AlertToggle = styled(SwitchButton)`
  width: 60px;
  height: 24px;

`
export const _InfoBlock = styled.div`
  width: 100%;
`

export const _AddRecipient = styled.div`
  > div {
    width: 100%;
    max-width: 292px;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    max-width: initial;
  }
`

export const _ListingNumbers = styled.div`
  position: absolute;
  bottom: 55px;
  right: 8px;
  z-index: 1;
  width: 85px;
  height: 21px;
  background: rgba(16, 16, 16, 0.6);
  border-radius: 2px;
  font-size: 12px;
  color: white;
  line-height: 21px;
  text-align: center;
`

export const _ImgContainer = styled.div`
  position: relative;
  display: flex;
  max-width: 400px;
  width: 100%;
  aspect-ratio: 14/9;
  overflow: hidden;
  .embla__slide {
    width: 100% !important;
  }
`
export const _AddRecipientMulti = styled(AddRecipientMulti)`
  > div {
    margin: 0;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    .moreRecipientText {
      margin: 12px 0;
    }
  }
`
